import React from 'react'
import './Style.css'

export default function CrossTheRoad() {
  return (
    <div className='containerGame'>
        <h1>Welcome To Gaming Space </h1>
     <div className='Gaming'>
        <a class="btn btn-primary" id='StartGaming' href="https://www.minijuegos.com/" target="iframe_a">Start Gaming </a>
        <iframe href="" name="iframe_a" height="1000px" width="100%" title="Iframe Example"/>
    </div>


    </div>
  )
}
